// The pre-chat form ("Enforce User Details") in a language – the same texts as the widget
// (ultimo-bots-widget src/index.js PRE_CHAT_TEXT), so the Design preview and the test chat show what visitors see.
// Field labels come translated from the backend (warm_lead_function -> user_display_i18n.labels).
export const PRE_CHAT_LANGS = [
  ['de', 'Deutsch'], ['en', 'English'], ['fr', 'Français'], ['es', 'Español'],
  ['it', 'Italiano'], ['pt', 'Português'], ['nl', 'Nederlands'], ['pl', 'Polski'],
];

export const PRE_CHAT_TEXT = {
  en: { title: 'Before we start chatting', subtitle: 'Please provide your details to continue',
        start: 'Start Chat', submitting: 'Submitting…', anyLanguage: 'You can chat with us in any language.' },
  de: { title: 'Bevor wir loslegen', subtitle: 'Bitte geben Sie Ihre Angaben ein, um fortzufahren',
        start: 'Chat starten', submitting: 'Wird gesendet…', anyLanguage: 'Sie können in jeder Sprache mit uns chatten.' },
  fr: { title: 'Avant de commencer', subtitle: 'Veuillez indiquer vos coordonnées pour continuer',
        start: 'Démarrer le chat', submitting: 'Envoi…', anyLanguage: 'Vous pouvez nous écrire dans n’importe quelle langue.' },
  es: { title: 'Antes de empezar', subtitle: 'Indique sus datos para continuar',
        start: 'Iniciar chat', submitting: 'Enviando…', anyLanguage: 'Puede escribirnos en cualquier idioma.' },
  it: { title: 'Prima di iniziare', subtitle: 'Inserisca i suoi dati per continuare',
        start: 'Avvia chat', submitting: 'Invio…', anyLanguage: 'Può scriverci in qualsiasi lingua.' },
  pt: { title: 'Antes de começarmos', subtitle: 'Indique os seus dados para continuar',
        start: 'Iniciar conversa', submitting: 'A enviar…', anyLanguage: 'Pode escrever-nos em qualquer língua.' },
  nl: { title: 'Voordat we beginnen', subtitle: 'Vul uw gegevens in om verder te gaan',
        start: 'Chat starten', submitting: 'Bezig met verzenden…', anyLanguage: 'U kunt in elke taal met ons chatten.' },
  pl: { title: 'Zanim zaczniemy', subtitle: 'Podaj swoje dane, aby kontynuować',
        start: 'Rozpocznij czat', submitting: 'Wysyłanie…', anyLanguage: 'Możesz pisać do nas w dowolnym języku.' },
};

export function preChatLang(language) {
  const code = String(language || 'en').slice(0, 2).toLowerCase();
  return PRE_CHAT_TEXT[code] ? code : 'en';
}

export function preChatTexts(language) {
  return PRE_CHAT_TEXT[preChatLang(language)];
}

// A field's label in the language: the translation, else the owner's label (first letter upper, as the widget).
export function preChatLabel(field, language, labels) {
  const lang = preChatLang(language);
  const translated = (labels || field?.user_display_i18n?.labels || {})[lang];
  const text = String(translated || field?.user_display || field?.name || '');
  return text.charAt(0).toUpperCase() + text.slice(1);
}
